import fileDownload from 'js-file-download'

export const downloadFile = fileDownload
